import { SideQuest } from '@/models/leaderboard';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardActivities',
})
export default class CmgLeaderboardActivities extends Vue {

    @Watch('$appStore.state.leaderboard.summerCampaigns', { deep: true })
    onSummerCampaignMilestonesChanged() {
      return this.milestonesEligibleForChooseYourOwnReward;
    }

    get sideQuests(): SideQuest[] {
      return this.$appStore.state.leaderboard.sideQuests;
    }

    get hasSideQuests(): boolean {
      return this.sideQuests?.length > 0;
    }

    get milestonesEligibleForChooseYourOwnReward() {
      return this.$appStore.state.leaderboard.summerCampaigns?.flatMap(campaign => 
        campaign.milestones.filter(milestone => milestone.eligibleForChooseYourOwnReward)
      ) ?? [];
    }

    get hasChooseYourOwnRewardEligibility(): boolean {
      return this.milestonesEligibleForChooseYourOwnReward.length > 0;
    }
}
